export function isDemo() {
  return window.location.origin.includes('demo')/*  || window.location.origin.includes('local') */
}
